import { TransactionTable } from "./components/TransactionTable";
import { TransactionsChart } from "./components/TransactionChart/TransactionsChart";
import { TransactionFilterChart } from "./components/TransactionFilter";
import useDashboard from "./useDashboard";
import SellerCards from "./components/SellerCards";
import { useOS } from "@/app/hooks/useOS";
import { ReferralCard } from "./components/ReferralCard";
import BannerSwiper from "./components/BannerSwiper";
import { UserRoleEnum } from "@/app/services/usersService/user";
import { StatisticsCard } from "./components/StatisticsCard";
import { useState } from "react";
import { cn } from "@/app/utils/cn";
import { Chart } from "iconsax-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/view/components/TabsTable";
import { AuthorizationTable } from "./components/AuthorizationTable";

export const Dashboard = () => {
  const {
    data,
    isLoading,
    isSeller,
    commissionAmmount,
    user,
    isLeader,
    isSupervisor,
    metric,
    setMetric,
  } = useDashboard();

  const { isIOS } = useOS();
  const [showCards, setShowCards] = useState(false);
  const [activeTab, setActiveTab] = useState("transactions");

  return (
    <>
      {isSupervisor && !isIOS ? (
        <section className="relative">
          <button
            onClick={() => setShowCards(!showCards)}
            className={cn(
              "absolute right-4 top-20 z-10 flex h-12 w-12 items-center justify-center rounded-full shadow-lg transition-all hover:scale-105",
              showCards
                ? "bg-primary text-white"
                : "border border-primary bg-white text-primary",
            )}
            title={showCards ? "Ver gráfico" : "Ver estatísticas"}
          >
            <Chart size={24} variant="Bold" />
          </button>

          {showCards ? (
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <section className="rounded-2xl border border-border p-5">
                <StatisticsCard />
              </section>
              <section className="flex flex-col gap-5 rounded-2xl border border-border p-5">
                <SellerCards value={commissionAmmount} />
              </section>
            </div>
          ) : (
            <section className="w-full rounded-3xl border border-gray01 p-5">
              <TransactionFilterChart setMetric={setMetric} metric={metric} />
              <TransactionsChart
                data={data}
                isLoading={isLoading}
                metric={metric}
              />
            </section>
          )}
        </section>
      ) : (
        <section className="flex flex-col-reverse gap-4 overflow-x-hidden 2xl:flex-row">
          {!isIOS && !isSeller && !isLeader && (
            <section className="hidden w-full rounded-3xl border border-gray01 p-5 sm:block">
              <TransactionFilterChart setMetric={setMetric} metric={metric} />
              <TransactionsChart
                data={data}
                isLoading={isLoading}
                metric={metric}
              />
            </section>
          )}
          {user?.role &&
            [UserRoleEnum.LEADER, UserRoleEnum.USER].includes(user.role) && (
              <div className="flex flex-col gap-4">
                <section className="flex flex-grow flex-col gap-5 rounded-2xl border border-border p-5 sm:min-w-[480px]">
                  <div className="hidden md:block">
                    <ReferralCard />
                  </div>
                  <BannerSwiper />
                </section>
              </div>
            )}
          <section className="flex-grow rounded-2xl border border-border p-5 sm:min-w-[465px]">
            <StatisticsCard />
          </section>
          {user?.role &&
            [UserRoleEnum.LEADER, UserRoleEnum.USER].includes(user.role) && (
              <section className="flex flex-grow flex-col gap-5 rounded-2xl sm:p-0 md:border md:border-border md:p-5">
                <SellerCards value={commissionAmmount} />
              </section>
            )}
        </section>
      )}

      <Tabs defaultValue="transactions" value={activeTab} onValueChange={setActiveTab} className="mt-6 w-full">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <TabsList className="flex items-center gap-4">
            <TabsTrigger value="transactions">Transações</TabsTrigger>
            <TabsTrigger value="authorizations">Autorizações</TabsTrigger>
          </TabsList>

          {(isIOS || isSeller || isLeader) && activeTab === "transactions" && (
            <div>
              <TransactionFilterChart
                variant="onlyButton"
                setMetric={setMetric}
                metric={metric}
              />
            </div>
          )}
        </div>

        <TabsContent value="transactions" className="mt-6">
          <TransactionTable />
        </TabsContent>

        <TabsContent value="authorizations" className="mt-6">
          <AuthorizationTable />
        </TabsContent>
      </Tabs>
    </>
  );
};
